import { forwardRef } from "react";
import { Flex } from "../Flex/Flex";
import type { FlexProps } from "../Flex/types";

export const HStack = forwardRef<HTMLElement, FlexProps>(function HStack(props, ref) {
    return <Flex direction="row" ref={ref} {...props} />;
});
